import { MainLoadingIndicator } from '../app/MainLoadingIndicator';
import { MapErrorBoundary } from './MapErrorBoundary';
import MapLoader from './MapLoader';
import MapWrapper from './MapWrapper';

export const Map = () => {
    const mapClassName = 'GeofenceAdministrationMap height-100pct';

    return (
        <div className={mapClassName}>
            <MapErrorBoundary>
                <MapLoader fallback={<MainLoadingIndicator />}>
                    <MapWrapper />
                </MapLoader>
            </MapErrorBoundary>
        </div>
    );
};
